ch-barcode-scanner {
  display: grid;
  position: relative;
  inline-size: 100%; // Necessary to work in the gx-table-cell control
  overflow: hidden; // For better compatibility
  overflow: clip; // Necessary to avoid the flickering in the initial load

  & > .ch-barcode-scanner-absolute {
    display: grid;
    align-self: center;
    position: absolute;
    inline-size: 100%;
  }
}
